<style>

::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-thumb {
  background: rgba(191, 188, 188, 0.6);
}
.required_err {
  color: rgba(255, 0, 0);
}

.br_tbl_td_bottom {
    border-top: none !important;
    border-right: none !important;
    border-left: none !important;
    border-bottom: thin solid rgba(0, 0, 0, 0.12) !important;
}

.br_tbl_td_no_borders {
    border-top: none !important;
    border-right: none !important;
    border-left: none !important;
    border-bottom: none !important;
}

tr:hover {
    background-color: transparent !important;
}

.br_rd_odd {
    background-color: rgba(0, 0, 0, .03) !important;
}

.rc_section {
    padding-top: 12px;
}

.br_label {
    color: rgba(0, 0, 0, 0.6);
    font-family: "Roboto", sans-serif;
    font-size: 14px;
    padding-bottom: 16px;
}

.br_section {
    padding-bottom: 16px;
}

.elevation-1 tr:nth-of-type(even) {
    background-color: rgba(0, 0, 0, .03) !important;
}

.v-label {
    font-size: 20px;
}

.msg_ok {
    color: rgba(0, 200, 0);
}

.msg_err {
    color: rgba(255, 0, 0);
}

.br {
    color: rgba(109, 103, 164);
}

</style>

<template>
    <div class="pppoe_settings">
        <div class="br_section"><h2 class="br">PPPoE settings</h2></div>
        <ValidationObserver ref="observer" v-slot="{ invalid }">

            <div class="br_section"><h3 class="br">PPPoE</h3></div>
            <ValidationProvider rules="required" v-slot="{ errors }">
                <v-text-field
                    v-model="settings.ac_cookie_key"
                    label="AC coockie key"
                ></v-text-field>
                <span class="required_err">{{ errors[0] }}</span>
            </ValidationProvider>

            <ValidationProvider rules="required" v-slot="{ errors }">
                <v-text-field
                    v-model="settings.ac_name"
                    label="AC name"
                ></v-text-field>
                <span class="required_err">{{ errors[0] }}</span>
            </ValidationProvider>

            <ValidationProvider v-slot="{ errors }">
                <v-text-field
                    v-model="settings.service_name"
                    label="PPPoE global service name"
                ></v-text-field>
                <span class="required_err">{{ errors[0] }}</span>
            </ValidationProvider>

            <div class="br_section"><h3 class="br">PPP</h3></div>

            <ValidationProvider rules="required" v-slot="{ errors }">
                <v-text-field
                    v-bind:readonly="true"
                    v-model="settings.ppp_1session_per_username_str"
                    label="Only single ppp session per username (readonly/startup only)"
                ></v-text-field>
                <span class="required_err">{{ errors[0] }}</span>
            </ValidationProvider>

            <ValidationProvider rules="required|numeric" v-slot="{ errors }">
                <v-text-field
                    v-model="settings.ppp_max_terminate"
                    label="ppp max terminate attempts"
                ></v-text-field>
                <span class="required_err">{{ errors[0] }}</span>
            </ValidationProvider>

            <ValidationProvider rules="required|numeric" v-slot="{ errors }">
                <v-text-field
                    v-model="settings.ppp_max_configure"
                    label="ppp max configure attempts"
                ></v-text-field>
                <span class="required_err">{{ errors[0] }}</span>
            </ValidationProvider>

            <ValidationProvider rules="required|numeric" v-slot="{ errors }">
                <v-text-field
                    v-model="settings.ppp_initial_restart_time"
                    label="ppp initial restart time, ms"
                ></v-text-field>
                <span class="required_err">{{ errors[0] }}</span>
            </ValidationProvider>

            <div class="br_section"><h3 class="br">LCP</h3></div>
            <ValidationProvider rules="required|numeric" v-slot="{ errors }">
                <v-text-field
                    v-model="settings.lcp_keepalive_num_retries"
                    label="LCP keepalive number of retries"
                ></v-text-field>
                <span class="required_err">{{ errors[0] }}</span>
            </ValidationProvider>   

            <ValidationProvider rules="required|numeric" v-slot="{ errors }">
                <v-text-field
                    v-model="settings.lcp_keepalive_interval"
                    label="LCP keepalive interval, seconds"
                ></v-text-field>
                <span class="required_err">{{ errors[0] }}</span>
            </ValidationProvider>

            <ValidationProvider rules="required|numeric" v-slot="{ errors }">
                <v-text-field
                    v-model="settings.lcp_keepalive_probe_interval"
                    label="LCP keepalive probe interval, ms"
                ></v-text-field>
                <span class="required_err">{{ errors[0] }}</span>
            </ValidationProvider>

            <ValidationProvider rules="required" v-slot="{ errors }">
                <v-combobox
                    v-model="settings.ppp_default_auth_proto"
                    label="LCP default authentication protocol"
                    :items="['chap', 'pap']"
                ></v-combobox>                    
                <span class="required_err">{{ errors[0] }}</span>
            </ValidationProvider>            

            <div class="br_section"><h3 class="br">IPCP</h3></div>
            <div class="br_section">
                <v-toolbar flat>
                    <v-toolbar-title>PPPoE IPv4 pools</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn @click="pppoe_ipv4_pools__show_add_form()">Add</v-btn>
                </v-toolbar>

                <div>
                    <ipv6_pool_box v-model="show_ipv6_ia_na_pool_form"
                        @canceled="ipv6_pool_ia_na_form__on_cancel" 
                        @selected="ipv6_pool_ia_na_form__on_select($event)">
                    </ipv6_pool_box>
                    <ipv6_pool_box v-model="show_ipv6_ia_pd_pool_form"
                        @canceled="ipv6_pool_ia_pd_form__on_cancel" 
                        @selected="ipv6_pool_ia_pd_form__on_select($event)">
                    </ipv6_pool_box>
                    <ipv6_pool_box v-model="show_ipv6_slaac_pool_form"
                        @canceled="ipv6_pool_slaac_form__on_cancel" 
                        @selected="ipv6_pool_slaac_form__on_select($event)">
                    </ipv6_pool_box>
                </div>

                <v-dialog v-model="new_ip_pool_dialog" max-width="700px">
                    <div>
                        <ip_pool_box v-model="show_ip_pool_form"
                            @canceled="ip_pool_form__on_cancel" 
                            @selected="ip_pool_form__on_select($event)">
                        </ip_pool_box>
                    </div>

                    <ValidationObserver ref="new_ip_pool_observer" v-slot="{ invalid }">
                        <v-card>
                            <v-card-title>
                                <span class="headline">
                                    Add a new pool to the list of PPPoE IPv4 pools</span>
                            </v-card-title>
                            <v-card-text>
                                <v-container style="height: 520px; overflow-y: scroll;">
                                    <v-row>
                                        <v-col cols="12">
                                            <ValidationProvider rules="required" v-slot="{ errors }">
                                                <v-text-field v-model="ip_pool_name"
                                                        label="IP pool name">
                                                    <template #append>
                                                        <v-btn @click="open_ip_pools_form()">...</v-btn>
                                                    </template>                          
                                                </v-text-field>
                                                <span class="required_err">{{ errors[0] }}</span>
                                            </ValidationProvider>
                                        </v-col>
                                    </v-row>  
                                </v-container>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="blue darken-1" text @click="pppoe_ipv4_pools__close_form">
                                    Cancel</v-btn>
                                <v-btn color="blue darken-1" :disabled="invalid"
                                        text @click="pppoe_ipv4_pools__save_form">
                                    Save</v-btn>
                            </v-card-actions>
                        </v-card>
                    </ValidationObserver>
                </v-dialog>

                <v-data-table
                        :headers="pppoe_ipv4_pools_hdrs"
                        :items="pppoe_ipv4_pools"
                        sort-by="pool_name"
                        hide-default-footer
                        class="elevation-1">
                    <template v-slot:item.actions="{ item }">
                        <v-icon small @click="pppoe_ipv4_pools__before_del(item)">
                            mdi-delete
                        </v-icon>
                    </template>
                    <template v-slot:no-data>
                        No records
                    </template>
                </v-data-table>
            </div>

            <ValidationProvider rules="required|ipv4_addr" v-slot="{ errors }">
                <v-text-field
                    v-model="settings.primary_dns"
                    label="Primary DNS"
                ></v-text-field>
                <span class="required_err">{{ errors[0] }}</span>
            </ValidationProvider>

            <ValidationProvider rules="required|ipv4_addr" v-slot="{ errors }">
                <v-text-field
                    v-model="settings.secondary_dns"
                    label="Secondary DNS"
                ></v-text-field>
                <span class="required_err">{{ errors[0] }}</span>
            </ValidationProvider>

            <ValidationProvider rules="required|ipv4_addr" v-slot="{ errors }">
                <v-text-field
                    v-model="settings.ipcp_our_ip_address"
                    label="IPCP local p-t-p address"
                ></v-text-field>
                <span class="required_err">{{ errors[0] }}</span>
            </ValidationProvider>


            <div class="br_section"><h3 class="br">IPv6</h3></div>

            <ValidationProvider rules="required" v-slot="{ errors }">
                <v-text-field
                    v-bind:readonly="true"
                    v-model="settings.ppp_ipv6_str"
                    label="PPP IPv6 protocol state (readonly/startup only)"
                ></v-text-field>
                <span class="required_err">{{ errors[0] }}</span>
            </ValidationProvider>

            <v-text-field
                v-model="settings.ia_na_pool"
                label="IPv6 IA NA pool">
                <template #append>
                    <v-btn @click="ipv6_pool_ia_na_form__show()">...</v-btn>
                </template>
            </v-text-field>

            <v-text-field
                v-model="settings.ia_pd_pool"
                label="IPv6 IA PD pool">
                <template #append>
                    <v-btn @click="ipv6_pool_ia_pd_form__show()">...</v-btn>
                </template>
            </v-text-field>

            <v-text-field
                v-model="settings.slaac_pool"
                label="IPv6 IA SLAAC pool">
                <template #append>
                    <v-btn @click="ipv6_pool_slaac_form__show()">...</v-btn>
                </template>
            </v-text-field>

            <div class="br_label">
                DHCPv6 IA NA
                <treeselect
                    v-model="settings.ppp_dhcpv6_ia_na"
                    :multiple="false" 
                    :options="dhcpv6_ia_options"
                />
            </div>

            <div class="br_label">
                DHCPv6 IA PD
                <treeselect
                    v-model="settings.ppp_dhcpv6_ia_pd"
                    :multiple="false" 
                    :options="dhcpv6_ia_options"
                />
            </div>

            <div class="br_label">
                DHCPv6 SLAAC
                <treeselect
                    v-model="settings.ppp_slaac"
                    :multiple="false" 
                    :options="on_off_options"
                />
            </div>

            <div class="br_label">
                Radius Accounting IA NA
                <treeselect
                    v-model="settings.ppp_rad_acct_ia_na"
                    :multiple="false" 
                    :options="on_off_options"
                />
            </div>

            <div class="br_label">
                Radius Accounting IA PD
                <treeselect
                    v-model="settings.ppp_rad_acct_ia_pd"
                    :multiple="false" 
                    :options="on_off_options"
                />
            </div>

            <div class="br_label">
                Radius Accounting SLAAC
                <treeselect
                    v-model="settings.ppp_rad_acct_slaac"
                    :multiple="false" 
                    :options="on_off_options"
                />
            </div>

            <v-toolbar flat>
                <span class="msg_ok">{{ ok_msg_text }}</span>
                <span class="msg_err">{{ err_msg_text }}</span>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="cancel()">
                    Cancel</v-btn>
                <v-btn color="blue darken-1" :disabled="invalid"
                        text @click="save()">
                    Save</v-btn>
            </v-toolbar>
        </ValidationObserver>
    </div>
</template>

<script>

import api_client from '../services/api.js';
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';
import { required, numeric } from 'vee-validate/dist/rules';
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import ip_pool_box from "../components/ip_pool_box.vue";
import ipv6_pool_box from "../components/ipv6_pool_box.vue";
import "../validation_rules.js"

export default {
    name: 'pppoe_settings',
    components: { 
        ValidationObserver, ValidationProvider, Treeselect, ip_pool_box, ipv6_pool_box
    },

    data: () => ({
        nb_vars: 0,
        var_ind: 0,

        show_ip_pool_form: false,

        show_ipv6_ia_na_pool_form: false,
        show_ipv6_ia_pd_pool_form: false,
        show_ipv6_slaac_pool_form: false,

        ip_pool_name: '',
        ip_pool_index: -1,
        new_ip_pool_dialog: false,
        pppoe_ipv4_pools: [],
        pppoe_ipv4_pools_hdrs: [
            { text: 'pool name', value: 'pool_name', align: 'start' },
            { text: 'Actions', value: 'actions', sortable: false },
        ],

        ok_msg_text: "",
        err_msg_text: "",

        on_off_options: [
          {
            id: '0',
            label: 'Off',
          },
          {
            id: '1',
            label: 'On',
          },
        ],

        dhcpv6_ia_options: [
          {
            id: '0',
            label: 'Off',
          },
          {
            id: '1',
            label: 'Allocate by request',
          },
          {
            id: '2',
            label: 'Allways allocate',
          },
        ],

        settings: {},
        old_settings: {},
    }),

    created() {
        this.initialize();
    },

    methods: {
        clear_msgs() {
            this.ok_msg_text = "";
            this.err_msg_text = "";
        },

        on_off_str(val) {
            if (val == 1) {
                return "On";
            }

            return "Off";
        },

        settings_calc_fields() {
            this.settings["ppp_1session_per_username_str"] = 
                this.on_off_str(this.settings["ppp_1session_per_username"]);
            this.settings["ppp_ipv6_str"] = this.on_off_str(this.settings["ppp_ipv6"]);
            this.old_settings = Object.assign({}, this.settings);
        },

        initialize() {
            return new Promise((resolve, reject) => {
                api_client.sh_pppoe_settings()
                .then(response => {
                    this.settings = response.data;
                    this.settings_calc_fields();

                    api_client.sh_pppoe_ip_pools()
                    .then(response => {
                        this.pppoe_ipv4_pools = response.data;
                        resolve(response);
                    })
                    .catch(error => {
                        console.log(error);
                    });                    
                })
                .catch(error => {
                    console.log(error);
                });
            });
        },

        save() {
            this.clear_msgs();
            this.nb_vars = Object.keys(this.settings).length;
            this.var_ind = 0;
            this.save_cb();
        },

        on_save_completed() {
            this.err_msg_text = "";
            this.ok_msg_text = "PPPoE settings have been successfully updated";
            this.settings_calc_fields();
            setTimeout(this.clear_msgs, 3000);
        },

        save_cb() {
            let key = Object.keys(this.settings)[this.var_ind];
            this.var_ind = this.var_ind + 1;
            let url = "";
            let data = {};

            if (this.old_settings[key] !== this.settings[key]) {
                switch (key) {
                case "ppp_max_terminate":
                case "ppp_max_configure":
                case "ppp_initial_restart_time":
                case "lcp_keepalive_num_retries":
                case "lcp_keepalive_interval":
                case "lcp_keepalive_probe_interval":
                case "ppp_dhcpv6_ia_na":
                case "ppp_dhcpv6_ia_pd":
                case "ppp_slaac":
                case "ppp_rad_acct_slaac":
                case "ppp_rad_acct_ia_na":
                case "ppp_rad_acct_ia_pd":
                    url = "/sysctl/set";
                    data["var_name"] = key;
                    data["value"] = this.settings[key];
                    break;
                case "ppp_default_auth_proto":
                    url = "/sysctl/set";
                    data["var_name"] = key;
                    data["value"] = '"' + this.settings[key] + '"';
                    break;
                case "primary_dns":
                    url = "/pppoe/set_dns_primary";
                    data["dns"] = this.settings[key];
                    break;
                case "secondary_dns":
                    url = "/pppoe/set_dns_secondary";
                    data["dns"] = this.settings[key];
                    break;
                case "ipcp_our_ip_address":
                    url = "/pppoe/set_ipcp_server";
                    data["ip"] = this.settings[key];
                    break;
                case "ac_cookie_key":
                    url = "/pppoe/set_ac_cookie";
                    data["prm"] = this.settings[key];
                    break;
                case "ac_name":
                    url = "/pppoe/set_ac_name";
                    data["prm"] = this.settings[key];
                    break;
                case "service_name":
                    url = "/pppoe/set_service_name";
                    data["prm"] = this.settings[key];
                    break;
                case "ia_na_pool":
                    data["pool_type"] = "ia_na";
                    if (this.settings[key].trim() === '') {
                        url = "/pppoe/disable_ppp_ipv6_pool";
                    }
                    else {
                        url = "/pppoe/set_ppp_ipv6_pool";
                        data["pool_name"] = this.settings[key];
                    }
                    break;
                case "ia_pd_pool":
                    data["pool_type"] = "ia_pd";
                    if (this.settings[key].trim() === '') {
                        url = "/pppoe/disable_ppp_ipv6_pool";
                    }
                    else {
                        url = "/pppoe/set_ppp_ipv6_pool";
                        data["pool_name"] = this.settings[key];
                    }
                    break;
                case "slaac_pool":
                    data["pool_type"] = "slaac";
                    if (this.settings[key].trim() === '') {
                        url = "/pppoe/disable_ppp_ipv6_pool";
                    }
                    else {
                        url = "/pppoe/set_ppp_ipv6_pool";                    
                        data["pool_name"] = this.settings[key];
                    }
                    break;
                };

                if (url !== "") {
                    api_client.run_post_query(url, data)
                    .then(response => {
                        if (response.data.hasOwnProperty("err_msg")) {
                            this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
                        }
                        else {
                            if (this.var_ind == this.nb_vars) {
                                this.on_save_completed();
                            }
                            else {
                                this.save_cb();
                            }
                        }
                    })
                    .catch(error => {
                        console.log(error);
                        this.$fire({title: "Command failed", text: error, type: "warning"});
                    });
                    
                    return;
                }
            }

            if (this.var_ind == this.nb_vars) {
                this.on_save_completed();
            }
            else {
                this.save_cb(); 
            }
        },

        cancel() {
            requestAnimationFrame(() => {
                this.$refs.observer.reset();
            });
            this.clear_msgs();
            this.initialize();
        },

        /*
         * PPPoE IPv4 pools
         */
        pppoe_ipv4_pools__delete() {
            api_client.pppoe_del_ip_pool({
                pool_name: this.ip_pool_name,
            })
            .then(response => {
                if (response.data.hasOwnProperty("err_msg")) {
                    this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
                }
                else {
                    this.pppoe_ipv4_pools.splice(this.ip_pool_index, 1)
                }
            })
            .catch(error => {
                console.log(error);
                this.$fire({title: "Command failed", text: error, type: "warning"});
            });
        },

        pppoe_ipv4_pools__before_del(item) {
            this.ip_pool_index = this.pppoe_ipv4_pools.indexOf(item);
            this.ip_pool_name = item.pool_name;
            this.$confirm("Are you sure you want to delete pool ''" + this.ip_pool_name +
                "'' from the list of PPPoE IPv4 pools ?")
            .then(() => {
                this.pppoe_ipv4_pools__delete();
            });
        },

        pppoe_ipv4_pools__show_add_form() {
            this.ip_pool_name = '';
            requestAnimationFrame(() => {
                this.$refs.new_ip_pool_observer.reset();
            });
            this.new_ip_pool_dialog = true;
        },

        pppoe_ipv4_pools__close_form() {
            this.new_ip_pool_dialog = false;
        },

        pppoe_ipv4_pools__save_form() {
            api_client.pppoe_add_ip_pool({
                pool_name: this.ip_pool_name,
            })
            .then(response => {
                if (response.data.hasOwnProperty("err_msg")) {
                    this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
                }
                else {
                    this.pppoe_ipv4_pools.push({pool_name: this.ip_pool_name});
                    this.pppoe_ipv4_pools__close_form();
                }
            })
            .catch(error => {
                console.log(error);
                this.$fire({title: "Command failed", text: error, type: "warning"});
            });
        },        

        /**/
        open_ip_pools_form() {
            this.show_ip_pool_form = true;
        },

        ip_pool_form__on_cancel() {
            this.show_ip_pool_form = false;
        },

        ip_pool_form__on_select(ip_pool_name) {
            this.ip_pool_name = ip_pool_name;
            this.show_ip_pool_form = false;
        },        

        /* ipv6 box ia na */
        ipv6_pool_ia_na_form__show() {
            this.show_ipv6_ia_na_pool_form = true;
        },

        ipv6_pool_ia_na_form__on_cancel() {
            this.show_ipv6_ia_na_pool_form = false;
        },

        ipv6_pool_ia_na_form__on_select(ipv6_pool_name) {
            this.settings["ia_na_pool"] = ipv6_pool_name;
            this.show_ipv6_ia_na_pool_form = false;
        },        

        /* ipv6 box ia pd */
        ipv6_pool_ia_pd_form__show() {
            this.show_ipv6_ia_pd_pool_form = true;
        },

        ipv6_pool_ia_pd_form__on_cancel() {
            this.show_ipv6_ia_pd_pool_form = false;
        },

        ipv6_pool_ia_pd_form__on_select(ipv6_pool_name) {
            this.settings["ia_pd_pool"] = ipv6_pool_name;
            this.show_ipv6_ia_pd_pool_form = false;
        },
        
        /* ipv6 box slaac */
        ipv6_pool_slaac_form__show() {
            this.show_ipv6_slaac_pool_form = true;
        },

        ipv6_pool_slaac_form__on_cancel() {
            this.show_ipv6_slaac_pool_form = false;
        },

        ipv6_pool_slaac_form__on_select(ipv6_pool_name) {
            this.settings["slaac_pool"] = ipv6_pool_name;
            this.show_ipv6_slaac_pool_form = false;
        },
    }
};
</script>
